import client from "../http-clients/api";
import noVersionClient from "@https/no-version-api";
import gate from "../gate";
import {
  IProgramInput,
  IProgramListInput,
  IProgramListOutput,
  IProgramListPyParams,
  IProgramOutput,
} from "@types";

const programApi = {
  getPrograms: (params?: IProgramListOutput) =>
    gate.get<IProgramListInput, never, IProgramListPyParams>({
      client: noVersionClient,
      url: "/py",
      params: {
        ...params,
        path: "/programs",
      },
    }),
  getProgram: (slug: string, params?: IProgramOutput) =>
    gate.get<IProgramInput, never, IProgramOutput>({
      client,
      url: `/programs/${slug}`,
      params,
    }),
};

export default programApi;
